import { render, staticRenderFns } from "./courseAuth.vue?vue&type=template&id=d31be1b4&scoped=true&"
import script from "./courseAuth.vue?vue&type=script&lang=js&"
export * from "./courseAuth.vue?vue&type=script&lang=js&"
import style0 from "./courseAuth.vue?vue&type=style&index=0&id=d31be1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31be1b4",
  null
  
)

export default component.exports